import React, { useContext } from 'react';
import DocsCtx from '../../../../../context/docsContext/docsCtx';
import useTranslate from '../../../../../common/hooks/useTranslate';

import { IDocumentsCell } from '../../../types/IDocumentsCell';

import Icon from '../../../../ui/icon/icon';

import './headerCell.scss';

const HeaderCell: React.FC<IDocumentsCell> = ({multipleDownload, field, onClick, onDownloadClick, title, children}) => {
  const { t } = useTranslate();
  const docsCtx = useContext(DocsCtx);

  let headerCellStyles;

  if (multipleDownload) {
    headerCellStyles = 'k-link download-padding';
  } else if (field === 'fileType') {
    headerCellStyles = 'k-link align-center';
  } else {
    headerCellStyles = 'k-link';
  }

  return (
    <div className={headerCellStyles} onClick={onClick}>
      {multipleDownload && (
        <>
          <div className="multiple-download" onClick={onDownloadClick}>
            <Icon className="actions-header-cell-icon" name="fas fa-file-zipper" />
            <span className="title">{docsCtx.selectedItemsIds.length} {t('DOCUMENTS_TABLE.LABEL_DOCUMENTS')}</span>
          </div>
        </>
      )}
      {!multipleDownload && <span>{title}</span>}
      {children}
    </div>
  );
};

export default HeaderCell;
